import Heading from '../../app/design/Heading'
import Paragraph from '../../app/design/Paragraph'
import { WorkflowPage } from '../../workflows/WorkflowPage'
import { Skeleton } from './Skeleton'

type Props = {
    title: string
    subtitle: string
    onClose: () => void
}

function SelectListItemSkeleton() {
    return (
        <div className="flex flex-row gap-x-2 rounded-lg border-2 border-gray-300 p-4">
            <Skeleton circle width={48} height={48} />
            <div className="flex flex-col gap-y-1">
                <Skeleton height={20} width={80} />
                <Skeleton height={16} width={48} />
            </div>
        </div>
    )
}

export function WorkflowSelectListSkeleton({ title, subtitle, onClose }: Props) {
    return (
        <WorkflowPage onClose={onClose}>
            <Heading size="xl" className="mt-[5px]">
                {title}
            </Heading>
            <Paragraph className="mt-4 max-w-[580px] text-center text-gray-600">
                {subtitle}
            </Paragraph>
            <WorkflowPage.Card className="mt-12">
                <div className="flex flex-col gap-y-3">
                    {[1, 2, 3, 4, 5].map((_, index) => (
                        <SelectListItemSkeleton key={index} />
                    ))}
                </div>
            </WorkflowPage.Card>
        </WorkflowPage>
    )
}
